export function percentage(percent: number, totalValue: number) {
  return (percent / 100) * totalValue;
}
